
import OptimizedMicrosoft365SecurityTransformation from "@/pages/case-studies/OptimizedMicrosoft365SecurityTransformation";
import BioMedTechSecurityTransformation from "@/pages/case-studies/BioMedTechSecurityTransformation";
import RegionalRestaurantChainTransformation from "@/pages/case-studies/RegionalRestaurantChainTransformation";
import OregonSkiResortSecuresSeasonal from "@/pages/case-studies/OregonSkiResortSecuresSeasonal";
import TechCompanyInfrastructureScaling from "@/pages/case-studies/TechCompanyInfrastructureScaling";
import TechStartupScalesSecurity from "@/pages/case-studies/TechStartupScalesSecurity";
import LegalFirmPracticeManagement from "@/pages/case-studies/LegalFirmPracticeManagement";
import FinancialServicesContinuity from "@/pages/case-studies/FinancialServicesContinuity";

export const caseStudyRoutes = [
  { path: "/case-studies/OptimizedMicrosoft365SecurityTransformation", element: <OptimizedMicrosoft365SecurityTransformation /> },
  { path: "/case-studies/biomedtech-security-transformation", element: <BioMedTechSecurityTransformation /> },
  { path: "/case-studies/RegionalRestaurantChainTransformation", element: <RegionalRestaurantChainTransformation /> },
  { path: "/case-studies/OregonSkiResortSecuresSeasonal", element: <OregonSkiResortSecuresSeasonal /> },
  { path: "/case-studies/TechCompanyInfrastructureScaling", element: <TechCompanyInfrastructureScaling /> },
  { path: "/case-studies/TechStartupScalesSecurity", element: <TechStartupScalesSecurity /> },
  { path: "/case-studies/legal-firm-practice-management", element: <LegalFirmPracticeManagement /> },
  { path: "/case-studies/financial-services-business-continuity", element: <FinancialServicesContinuity /> },
];
